exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".planPageContainer--3oZGz {\n    max-width: 784px;\n}\n.planPage__title--17xZm {\n        font-size: 34px;\n        line-height: 48px;\n    }\n.planPage__caption--3OlF_ {\n\n    }\n", ""]);

// Exports
exports.locals = {
	"planPageContainer": "planPageContainer--3oZGz",
	"planPage__title": "planPage__title--17xZm",
	"planPage__caption": "planPage__caption--3OlF_"
};